// 로그인 감사 보고 — 접속 플랫폼(웹/데스크톱앱/Android앱/iOS)을 사이드카에 기록.
// 비밀번호 로그인은 항상 기록, 자동로그인(저장 토큰)은 탭/앱 실행당 1회만 (sessionStorage 가드).
// 실패는 조용히 무시 — 감사 기록이 로그인 흐름을 막으면 안 됨.

import { isTauri } from '../desktop/env';

const REPORTED_KEY = 'tpt_login_audit_reported';

// 클라이언트 자가판별 — Tauri 데스크톱은 UA 로 구분 불가(WebView2=Edge UA)라 자가보고 필수.
// Android 웹뷰 래퍼는 UA 의 "; wv)" 마커, iOS 앱(향후 WKWebView)은 Safari 토큰 없는 iPhone/iPad UA.
export function detectPlatform(): 'web' | 'desktop' | 'android' | 'ios' {
	if (isTauri()) return 'desktop';
	const ua = navigator.userAgent;
	if (/Android/i.test(ua) && /; wv\)/.test(ua)) return 'android';
	if (/iPhone|iPad|iPod/i.test(ua) && !/Safari\//i.test(ua)) return 'ios';
	return 'web';
}

export function reportSessionStart(authToken: string, userId: string, method: 'password' | 'token'): void {
	try {
		if (method === 'token' && sessionStorage.getItem(REPORTED_KEY) === userId) return;
		sessionStorage.setItem(REPORTED_KEY, userId);
	} catch { /* private mode — 가드 없이 진행 */ }
	void fetch('/api/tpt/login-audit', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'X-Auth-Token': authToken, 'X-User-Id': userId },
		body: JSON.stringify({ platform: detectPlatform(), method }),
	}).catch(() => undefined);
}
